import React, { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";

// Smooth momentum scrolling. Respects prefers-reduced-motion.
export default function SmoothScroll({ children }) {
  const reduced = typeof window !== "undefined" &&
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduced) return <>{children}</>;

  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      {children}
    </ReactLenis>
  );
}
